import {Component, OnInit} from '@angular/core';
import {ApiUserService} from '../service/api-user.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {

  keyVal: string;
  response = {
    severity: null,
    message: null
  }

  constructor(public apiUserService: ApiUserService,
              public route: ActivatedRoute) {

  }

  ngOnInit() {
    this.keyVal = this.route.snapshot.params.key;
    this.apiUserService.verifyApiKeyUserEmail(this.route.snapshot.params.key)
      .subscribe((res) => {
          if (res['message'] === 'User is already activated') {
            this.response = {
              severity: 'alreadyActivated',
              message: res['message']
            };
          } else {
            this.response = {
              severity: 'success',
              message: 'Your e-mail address has been verified. Your LNPS user account is now active.'
            };
          }
        },
        (err) => {
          this.response = {
            severity: 'failure',
            message: 'Failed to activate account.'
          };
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/verify-email/verify-email.component.ts